import {Component, OnInit} from '@angular/core';
import {IEmailModel} from '../../core/interfaces/email.interface';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalDataSource} from '../../piquant-table/data/local-datasource';
import {ITableSettings} from '../../piquant-table/models';
import {EmailStatus} from '../../core/enums/email-status.enum';
import { GridOptions, GridApi, GridReadyEvent } from "ag-grid-community";
import { ViewButtonRendererComponent } from '../view-button-renderer/view-button-renderer.component';
import {FilterEmailStatusComponent} from '../filter-grid-status/filter-grid-status.component';
import {AuthService} from '../../auth/auth.service';

@Component({
    selector: 'list-email',
    templateUrl: './list-email.component.html',
    host: {
        '(window:resize)': 'onResize($event)'
    },
    standalone: false
})
export class ListEmailComponent implements OnInit {
  public psTableSettings: ITableSettings;
  public emails: LocalDataSource = new LocalDataSource();
  public gridOptions: GridOptions;
  public inputQuickSearch: string;
  public selectedPaginationOption = 2;
  public paginationOptions = [
    //{id: 0, name: "Auto"}, Weird bug only on this page? disabling for now.
    {id: 0, name: "10"},
    {id: 1, name: "50"},
    {id: 2, name: "100"},
    {id: 3, name: "500"}
  ];
  private gridApi!: GridApi;
  public emailsRows: IEmailModel[] = [];

  onGridReady = (e: GridReadyEvent) => {
    this.gridApi = e.api;
    this.gridApi.sizeColumnsToFit();
    this.loadGridPreferences();
  };

  constructor(private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,) {
      this.gridOptions = <GridOptions> {
      onGridReady: this.onGridReady,
      columnDefs: this.createColumnDefs(),
      rowHeight: 48, // recommended row height for material design data grids,
      headerHeight: 38,
      rowBuffer: 5, // This is set very low right now because of poor performance for the ngb Popover workaround in place. Default is 20
      animateRows: true,
      pagination: true,
      suppressCellFocus: true,
      suppressMenuHide: true,
      getRowClass: (event) => this.rowBackgroundColor(event),
      onSortChanged: () => this.onColumnChanged(),
      onColumnResized: () => this.onColumnChanged(),
      onFilterChanged: (event) => this.onFilterChanged(event),
      context: { componentParent: this },   // Make this component (and its members) available to child components.
      defaultColDef: {
        resizable: true,
        sortable: true
      }
    }
  }

  onResize(event) {
    localStorage.setItem('emailsWindowWidth', JSON.stringify(event.target.innerWidth));
    this.gridApi.sizeColumnsToFit();
  }

  private createColumnDefs() {
    return [
      {
        headerName: "Id",
        field: "emailQueueId",
        menuTabs: [],
        cellRenderer: ViewButtonRendererComponent,
        sort: 'desc',
        icons: {
          sortAscending: '<i class="fa fa-sort-alpha-asc"/>',
          sortDescending: '<i class="fa fa-sort-alpha-desc"/>',
          filter: '<i class="fa fa-search"/>',
          menu: '<i class="fa fa-filter"/>'
        }
      },
      {
        headerName: "Created Date",
        field: "createDate",
        filter: "agDateColumnFilter",
        menuTabs: ['filterMenuTab'],
        valueFormatter: this.dateCellFormatter,
        icons: {
          sortAscending: '<i class="fa fa-arrow-up"/>',
          sortDescending: '<i class="fa fa-arrow-down"/>',
          filter: '<i class="fa fa-search"/>',
          menu: '<i class="fa fa-filter"/>'
        }
      },
      {
        headerName: "To",
        field: "toEmail",
        filter: "agTextColumnFilter",
        menuTabs: ['filterMenuTab'],
        icons: {
          sortAscending: '<i class="fa fa-sort-alpha-asc"/>',
          sortDescending: '<i class="fa fa-sort-alpha-desc"/>',
          filter: '<i class="fa fa-search"/>',
          menu: '<i class="fa fa-filter"/>'
        }
      },
      {
        headerName: "subject",
        field: "subject",
        filter: "agTextColumnFilter",
        menuTabs: ['filterMenuTab'],
        icons: {
          sortAscending: '<i class="fa fa-sort-alpha-asc"/>',
          sortDescending: '<i class="fa fa-sort-alpha-desc"/>',
          filter: '<i class="fa fa-search"/>',
          menu: '<i class="fa fa-filter"/>'
        }
      },
      {
         headerName: "Status",
        field: "status",
        valueFormatter: this.emailStatusFormatter,
        filter: FilterEmailStatusComponent,
        menuTabs: ['filterMenuTab'],
        icons: {
          sortAscending: '<i class="fa fa-arrow-up"/>',
          sortDescending: '<i class="fa fa-arrow-down"/>',
          filter: '<i class="fa fa-search"/>',
          menu: '<i class="fa fa-filter"/>'
        }
      },
    ];
  }

ngOnInit(): void {
    // Populate data without touching the grid API
    this.route.data.subscribe((data: any) => {
      const emails = (data.emails as IEmailModel[]) ?? [];
      this.emailsRows = emails;   // <-- [rowData] binding updates the grid
      this.emails.load(emails);
      // If grid is already ready, we can fit columns again
      this.gridApi?.sizeColumnsToFit();
    });
  }

  //Move this to shared?
  private dateCellFormatter(params) {
    const thisDate: Date = new Date(params.value);
    return `${(thisDate.getMonth() + 1)}/${thisDate.getDate()}/${thisDate.getFullYear()}`;
  }

  private emailStatusFormatter(params){
    return EmailStatus[params.value];
  }

  public rowBackgroundColor(event) : string{
    if (event.node.rowIndex % 2 === 0) {
      return 'shaded-row';
    }
    else
      return null;
  }

  public setPageSize(paginationOption)
  {
    //Current version of AG Grid appears to have problems with autopagination (at least if it's turned on at runtime)... disabling.
    // if(paginationOption != 0)
    // {
      this.gridOptions.paginationAutoPageSize = false;
      this.gridApi.setGridOption('paginationPageSize',Number( (this.paginationOptions[paginationOption]) ? this.paginationOptions[paginationOption].name : 100));
    // }
    // else
    // {
    //   this.gridOptions.paginationAutoPageSize = true;
    //   //this.gridOptions.api.doLayout();
    //   this.gridOptions.api.redrawRows();
    // }
  }

  public onFilterTextBoxChanged() {
      this.gridApi.setGridOption('quickFilterText',this.inputQuickSearch);
  }

  public ngAfterViewInit() {
    
  }

  public loadGridPreferences() {
    //Handle loading saved Sort, Filter, and Column settings.
 if (!this.gridApi) return;

    const colKey = 'gridEmailsColumnState' + this.getImpersonatedUserId();
    const columnState = localStorage.getItem(colKey);
        if (columnState != null) {
      this.gridApi.applyColumnState(JSON.parse(columnState));
      //Prevent poor column saved states when a user's window size changes between sessions.
      if (+localStorage.getItem('emailsWindowWidth') != window.innerWidth) {
        this.gridApi.sizeColumnsToFit();
        localStorage.setItem('emailsWindowWidth', JSON.stringify(window.innerWidth));
      }
    }
    else {
      this.gridApi.sizeColumnsToFit();
      this.resetFilters();
    }
    var filterModel = localStorage.getItem('gridEmailsFilterModel' + this.getImpersonatedUserId());
    if (filterModel != null) {
      const thisModel = JSON.parse(filterModel);
      this.gridApi.setFilterModel(thisModel);     
    }
    else
      this.resetFilters();
    //Also attempt to load pagination selection
    var paginationOption = localStorage.getItem('gridEmailsPagination' + this.getImpersonatedUserId());
    if (paginationOption != null)
      this.onChangePaginationOption(Number(paginationOption));
  }

  public resetFilters() {
  // 1) Reset pagination option (your existing helper)
  this.onChangePaginationOption(2);

  // 2) Clear all filters in one shot (replaces looping + destroyFilter)
  this.gridApi.setFilterModel(null);

  // 3) Reset quick filter text (replaces api.setQuickFilter)
  this.inputQuickSearch = '';
  this.gridApi.setGridOption('quickFilterText', '');

  // 4) Reset columns to defaults (replaces columnApi.resetColumnState on gridOptions)
  this.gridApi.resetColumnState();

  // 5) Fit columns (keep)
  this.gridApi.sizeColumnsToFit();

  // NOTE: No manual onSortChanged/onFilterChanged calls needed anymore.
}

  public get isRoleClient() {
    return this.authService.isRoleClient;
  }

  public onColumnChanged() {
    localStorage.setItem('gridEmailsColumnState' + this.getImpersonatedUserId(), JSON.stringify(this.gridApi.getColumnState())); //get/applyColumnState()
  }

  public onFilterChanged(event) {
    localStorage.setItem('gridEmailsFilterModel'+this.getImpersonatedUserId(), JSON.stringify(this.gridApi.getFilterModel()));
  }

  public getImpersonatedUserId(): string
  {
    return (this.authService.impersonatedUser != null) ? this.authService.impersonatedUser.userId.toString() : this.authService.userId.toString();
  }

  public onChangePaginationOption(option)
  {
    this.selectedPaginationOption = option; // event.target.value;
    this.setPageSize(this.selectedPaginationOption);
    localStorage.setItem('gridEmailsPagination'+this.getImpersonatedUserId(), this.selectedPaginationOption.toString());
  }
}
